module.exports = __webpack_public_path__ + "img/slide-13.b725fdf9.jpg";